import React, { useState } from 'react';

import Modal from '@material-ui/core/Modal';
import { Grid, Backdrop } from '@mui/material';
import { makeStyles, Theme, createStyles } from '@material-ui/core/styles';

import { Register, Login } from '../Pages';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    authModal: {
      position: 'absolute',
      [theme.breakpoints.up('xs')]: {
        width: 340,
      },
      [theme.breakpoints.up('sm')]: {
        width: 530,        
      },
      [theme.breakpoints.up('lg')]: {
        width: 650,
      },   
      height: 'min(800, 90vh)',   
      overflow: 'auto',
      backgroundColor: 'white',
      borderRadius: 10,
      boxShadow: theme.shadows[5],
      padding: theme.spacing(2, 4, 3),
    },
  })
);

const AuthModal = ({
  authModalOpen,
  setAuthModalOpen,
  getUserInfo,
  getTokenThunk,
  matches,
  landing,
}) => {
  const classes = useStyles();
  const isLoggedIn = Boolean(getTokenThunk());
  console.log('isLoggedIn', isLoggedIn);

  const [signupPage, setSignupPage] = useState(true);

  const redirectToLoginPage = () => {
    setSignupPage(false);
  };

  const redirectToSignupPage = () => {
    setSignupPage(true);
  };

  return (
    <Modal
      open={authModalOpen}
      onClose={() => {
        setAuthModalOpen(false);
      }}
      aria-labelledby="auth-modal"
      aria-describedby="auth-modal-description"
      BackdropComponent={Backdrop}
    >
      <Grid
        container
        spacing={0}
        direction="column"
        alignItems="center"
        justifyContent="center"
        sx={{ minHeight: '100vh' }}
      >
        <div className={`${classes.authModal} modal-custom`}>
          {signupPage ? (
            <Register
              redirectToLoginPage={redirectToLoginPage}
              getUserInfo={getUserInfo}
              landing={landing}
              device={matches ? 'mobile' : 'desktop'}
            />
          ) : (
            <Login redirectToSignupPage={redirectToSignupPage} />
          )}
        </div>
      </Grid>
    </Modal>
  );
};

export default AuthModal;
